var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#account-points--mASgR';
                    var viewUrl = 'sprites.svg#view-account-points--mASgR';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 62 58',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };